<button
  [class]="size"
  [ngClass]="{disabled, loading}"
  [disabled]="disabled"
  [type]="type"
  (click)="handleClick()"
>
  <ng-content *ngIf="!loading; else loadingTemplate" />
</button>

<ng-template #loadingTemplate>
  <span class="loading-spinner">...</span>
</ng-template>
